import { ChordLib } from '@tunasong/music-lib'
import type { Chord, NoteEvent } from '@tunasong/music-lib'
import type { NoteName } from '@tunasong/schemas'

/**
 * Build NoteEvents for one chord at a given octave + duration.
 * Used by stab-scheduler-driven playback hooks across the music-theory tools.
 */
export const chordToEvents = (
  chord: Chord,
  duration: NoteEvent['duration'],
  octave = 4
): NoteEvent[] =>
  ChordLib.getNotes(chord).map(n => ({
    type: 'note' as const,
    note: `${n}${octave}` as NoteName,
    duration,
  }))
